import dashboardReducer from "./dashboardSlice";

export default dashboardReducer;
